import { BestSellerProductType, ProductType } from '../../../../types/product';
import { Customer } from '../../../../selectors/select-customer/types';
import { NEW_PRODUCTS_FOR_BYOC_FEWER_INCLUSIONS } from '../../../../ahm-constants/ui';
import getBestSeller from '../get-best-seller';

const getProductIdsWithFewerInclusions = (
  loadingState: boolean,
  errorState: boolean,
  productIds: ProductType['id'][],
  productType: BestSellerProductType,
  scale: Customer['scale'],
): {
  productIds: ProductType['id'][];
  hasProductWithFewerInclusions: boolean;
} => {
  if (loadingState || errorState || productIds.length > 1) {
    return {
      hasProductWithFewerInclusions: false,
      productIds,
    };
  }

  const bestSellerId = getBestSeller({ productType, scale });

  if (bestSellerId) {
    return {
      hasProductWithFewerInclusions: true,
      productIds: [...productIds, bestSellerId],
    };
  }

  const newProductsWithFewerInclusions =
    productType in NEW_PRODUCTS_FOR_BYOC_FEWER_INCLUSIONS
      ? NEW_PRODUCTS_FOR_BYOC_FEWER_INCLUSIONS[productType as keyof typeof NEW_PRODUCTS_FOR_BYOC_FEWER_INCLUSIONS]
      : null;

  const newProductToDisplay: string | null =
    newProductsWithFewerInclusions && scale in newProductsWithFewerInclusions
      ? newProductsWithFewerInclusions[scale as keyof typeof newProductsWithFewerInclusions]
      : null;

  if (newProductToDisplay) {
    return {
      hasProductWithFewerInclusions: true,
      productIds: [...productIds, newProductToDisplay],
    };
  }

  return {
    hasProductWithFewerInclusions: false,
    productIds,
  };
};

export default getProductIdsWithFewerInclusions;
